module.exports = __webpack_public_path__ + "img/1.facad44f.jpg";